/* eslint-disable camelcase */

import ImageData from './Image';

class ContactData {
  constructor({
    attributes: {
      SEO_meta_tags,
      title_line_1,
      title_line_2,
      form_description,
      hero_image_1,
      hero_image_2,
      section_2_image
    }
  }) {
    this.connectWithUs = {
      title1: title_line_1,
      title2: title_line_2,
      description: form_description
    };

    this.metaTags = SEO_meta_tags?.map(
      ({ id, meta_tag_name: name, meta_tag_content: content }) => ({
        id,
        name,
        content
      })
    );

    this.section_2_image = new ImageData(section_2_image?.data);
    this.heroImage1 = new ImageData(hero_image_1?.data);
    this.heroImage2 = new ImageData(hero_image_2?.data);
  }
}

export default ContactData;
